define( 'component',[ 'jquery' ],
function( $ ) {

	'use strict';

	/**
	 * Iterates over all $components and initiates component controller.
	 */

	return {

		init: function( $components ) {

			// if initComponent was invoked, use $components. otherwise it's the bootstrap init call
			if ( typeof( $components ) === 'undefined' ) {

				$components = $( '[ data-component ]' );

			}

			$components.each( function() {

				var $component = $( this ),
					id = $component.data( 'component' );
					

				//Retrieves the id of the module from the 'component' data attribute and calls the relevant controller.
				require( [ '../src/sublayouts/' + id + '/' + id ], function( Component ) {

					var component;

					if ( Component !== undefined ) {

						component = new Component( $component );
						component.init();
					}
				} );
			} );
		}
	};
} );

